import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';

const TermsOfServicePage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-emerald-50">
      <div className="max-w-4xl mx-auto px-6 py-12">
        {/* 返回按钮 */}
        <div className="mb-8">
          <Link
            to="/auth/register"
            className="inline-flex items-center text-emerald-600 hover:text-emerald-700 transition-colors"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-2" />
            返回注册
          </Link>
        </div>

        {/* 页面标题 */}
        <div className="bg-white rounded-2xl shadow-lg border border-emerald-100 p-8 md:p-12">
          <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            服务条款
          </h1>
          <p className="text-gray-500 mb-8">最后更新时间：2025年1月</p>

          <div className="prose prose-emerald max-w-none">
            {/* 欢迎语 */}
            <section className="mb-8">
              <p className="text-gray-700 leading-relaxed">
                欢迎使用离岸绿色债券直通车（Offshore Green Bond
                Express）平台。请仔细阅读以下服务条款。使用本平台即表示您同意遵守这些条款。
              </p>
            </section>

            {/* 第1条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                1. 服务说明
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                离岸绿色债券直通车平台（以下简称"本平台"）为绿色债券发行人、投资机构、认证机构及咨询服务商提供专业的绿色债券发行服务和信息交流平台。
              </p>
              <p className="text-gray-700 leading-relaxed">
                本平台提供的服务包括但不限于：项目筛选、详细评估、尽职调查、发行准备、上市交易等流程管理功能。
              </p>
            </section>

            {/* 第2条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                2. 用户注册与账户
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>用户注册时必须提供真实、准确、完整的信息</li>
                <li>用户有责任维护账户安全，妥善保管登录凭证</li>
                <li>用户对其账户下的所有活动承担责任</li>
                <li>如发现账户被未经授权使用，应立即通知平台管理员</li>
              </ul>
            </section>

            {/* 第3条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                3. 用户行为规范
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                用户在使用本平台时，同意不会：
              </p>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>上传或传播虚假、误导性信息</li>
                <li>侵犯他人的知识产权或其他合法权益</li>
                <li>干扰或破坏平台的正常运行</li>
                <li>未经授权访问他人账户或数据</li>
                <li>从事任何违法或违反行业规范的行为</li>
              </ul>
            </section>

            {/* 第4条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                4. 知识产权
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                本平台的所有内容，包括但不限于文字、图片、软件、代码、设计等，均受知识产权法保护。未经授权，用户不得复制、修改、传播或用于商业用途。
              </p>
            </section>

            {/* 第5条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                5. 免责声明
              </h2>
              <ul className="list-disc list-inside space-y-2 text-gray-700">
                <li>本平台提供的信息仅供参考，不构成投资建议</li>
                <li>平台不对第三方提供的信息的准确性、完整性承担责任</li>
                <li>用户应自行承担使用本平台服务的风险</li>
                <li>在法律允许的范围内，平台不对间接损失承担责任</li>
              </ul>
            </section>

            {/* 第6条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                6. 服务变更与终止
              </h2>
              <p className="text-gray-700 leading-relaxed">
                平台保留随时修改、暂停或终止部分或全部服务的权利，无需事先通知。对于因服务变更或终止造成的不便，平台不承担责任。
              </p>
            </section>

            {/* 第7条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                7. 数据保护
              </h2>
              <p className="text-gray-700 leading-relaxed">
                我们重视用户隐私保护。关于个人数据的收集、使用和保护，请参阅我们的
                <Link
                  to="/privacy"
                  className="text-emerald-600 hover:text-emerald-700 font-medium mx-1"
                >
                  隐私政策
                </Link>
                。
              </p>
            </section>

            {/* 第8条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                8. 法律适用与争议解决
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                本服务条款的解释、效力及争议解决，适用中华人民共和国法律。
              </p>
              <p className="text-gray-700 leading-relaxed">
                因本服务条款产生的任何争议，双方应友好协商解决；协商不成的，任何一方可向平台所在地有管辖权的人民法院提起诉讼。
              </p>
            </section>

            {/* 第9条 */}
            <section className="mb-8">
              <h2 className="text-2xl font-semibold text-gray-900 mb-4">
                9. 联系我们
              </h2>
              <p className="text-gray-700 leading-relaxed mb-3">
                如对本服务条款有任何疑问，请通过以下方式联系我们：
              </p>
              <ul className="list-none space-y-2 text-gray-700">
                <li>电子邮件：marketing@bravowhale.com</li>
                <li>客服电话：+86 21 5077 7029</li>
              </ul>
            </section>

            {/* 生效日期 */}
            <section className="mt-12 pt-8 border-t border-gray-200">
              <p className="text-gray-600 text-sm">
                本服务条款自2026年1月1日起生效。平台保留随时修改本条款的权利，修改后的条款将在平台上公布。
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
